<ng-template>
  <li class="td-wb-simplified-list-item">
    <ng-content />
  </li>
</ng-template>
